import React from 'react';
import QuoteLayout from '../../components/QuoteLayout/quote-layout';
import QuoteContext from '../../context/quote-context';
import DietaryRestrictionsSpecifics from '../../components/GetQuoteSteps/dietary-restrictions-specifics';

export default function QuoteDietaryRestrictionsSpecificsPage() {
  return (
    <QuoteLayout>
      <QuoteContext.Consumer>
        {quote => (
          <DietaryRestrictionsSpecifics
            set={quote.set}
            vegetarian={quote.vegetarian}
            vegan={quote.vegan}
            noGluten={quote.noGluten}
            noNuts={quote.noNuts}
            noShellfish={quote.noShellfish}
            noDairy={quote.noDairy}
            otherRestrictions={quote.otherRestrictions}
          />
        )}
      </QuoteContext.Consumer>
    </QuoteLayout>
  );
}
